import React from "react";

interface ArrowBackIconProps {
  width?: string;
  height?: string;
  fill?: string;
}

const ArrowBackIcon: React.FC<ArrowBackIconProps> = ({
  width = "24px",
  height = "24px",
  fill = "currentColor",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 12H5M12 19L5 12L12 5"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowBackIcon;

